import { BuiltinInstanceMemberValue } from '../BuiltinInstanceMemberValue';
export class SysCallInstanceMemberPrimitive extends BuiltinInstanceMemberValue {
    constructor(syscall, valueType, type) {
        super();
        this.syscall = syscall;
        this.valueType = valueType;
        this.type = type;
    }
    emit(sb, node, options) {
        sb.emitHelper(node, options, sb.helpers.unwrapVal({ type: this.valueType }));
        sb.emitSysCall(node, this.syscall);
        sb.emitHelper(node, options, sb.helpers.wrapVal({ type: this.type }));
    }
}

//# sourceMappingURL=SysCallInstanceMemberPrimitive.js.map
